import React, { Component } from 'react';
import { Modal, Header, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import ResetForm from './ResetForm';
import { FieldEnum } from '../../../common/FieldEnum';

class ResetModalContainer extends Component {
  state = {
    isValid: false,
  };

  renderErrors = () => {
    const { errors } = this.props;

    return errors.map(error => {
      return <div>error.Message</div>;
    });
  };

  renderButton = () => {
    const { isSubmitting } = this.props;
    if (isSubmitting) {
      return (
        <Button
          loading
          disabled
          inverted
          color="orange"
          size="big"
          content="Save"
        />
      );
    } else {
      return (
        <Button
          inverted
          color="orange"
          size="big"
          content="Save"
          disabled={!this.state.isValid}
          onClick={() => {
            this.form.submit();
          }}
          loading={isSubmitting}
        />
      );
    }
  };

  render() {
    const { Id, FirstName, LastName, UserName } = this.props.modalData;
    return (
      <div>
        <Modal
          open={this.props.showResetModal}
          onClose={this.props.onResetClose}
          closeIcon
          closeOnRootNodeClick={false}
        >
          <Header
            content={`Reset Password For ${UserName} - ${FirstName} ${LastName}`}
            icon="repeat flipped horizontally"
          />
          <Modal.Content>
            <Modal.Description>
              <ResetForm
                onSubmit={this.props.handleSubmit}
                ref={instance => {
                  this.form = instance;
                }}
                initialValues={{
                  [FieldEnum.Id]: Id,
                }}
                setIsValid={isValid => {
                  this.setState({ isValid });
                }}
              />
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>{this.renderButton()}</Modal.Actions>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = ({ UserSetupState }) => {
  return {
    isSubmitting: UserSetupState.result.isSubmitting,
    isDone: UserSetupState.result.isDone,
    errors: UserSetupState.result.errors,
  };
};

export const ResetModal = connect(
  mapStateToProps,
  null
)(ResetModalContainer);
//export { ResetModal }



// WEBPACK FOOTER //
// ./src/pages/usersetup/components/ResetModal.js